import { useEffect, useRef, useState } from 'react';

/** True once the element has come near the viewport; stays true (lazy image loading). */
export function useInView<T extends HTMLElement>(): { ref: React.RefObject<T | null>; inView: boolean } {
    const ref = useRef<T>(null);
    const [inView, setInView] = useState(false);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setInView(true);
                    observer.disconnect();
                }
            },
            { rootMargin: '100px' }
        );

        if (ref.current) {
            observer.observe(ref.current);
        }

        return () => observer.disconnect();
    }, []);

    return { ref, inView };
}
